import { generateActions } from "helpers/generateActions";

export const LEAVE_MESSAGE = generateActions("LEAVE_MESSAGE");

export const REQUEST_CALL_BACK = generateActions("REQUEST_CALL_BACK");

export const API_ERROR = "API_ERROR";
